import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {externalMailingListEdit_template} from "../components/templates/externalMailingListEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class external_mailing_list_edit extends vnModule_knockoutJS{
    protected externalMailingListEdit : externalMailingListEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.externalMailingListEdit = new externalMailingListEdit_template('externalMailingListEdit', this.viewModel, this)
        return [this.externalMailingListEdit.build()]
    }

    protected getModuleName(): string {
        return "external_mailing_list_edit";
    }

    public fillPage() {
        this.getMailingListDataForEdit()
    }

    private getMailingListDataForEdit() {
        this.loadingIn(this.externalMailingListEdit.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/external-mailingList/get/edit/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetMailingListDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetMailingListDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let mailingList = responseParsed.data
                obj.setMailingListData(mailingList);
            });

            obj.loadingOut(obj.externalMailingListEdit.builtTemplate);
        }
    }

    protected setMailingListData(mailingList) {
        this.externalMailingListEdit.setId(mailingList.id)
        this.externalMailingListEdit.setIdMailingList(mailingList.idMailingList)
        this.externalMailingListEdit.setLabel(mailingList.label)
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/external-mailing-lists/")
    }


    protected save(){
        this.loadingIn(this.externalMailingListEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/external-mailingList/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/external-mailing-lists/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Mailing list saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }

                });
                obj.loadingOut(obj.externalMailingListEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }
}


// WEBPACK FOOTER //
// ./js/modules/external_mailing_list_edit.ts